/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_GamingInputs */

const he_home_category_gaming = /** @type {(inputs: Home_Category_GamingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גיימינג`)
};

const en_home_category_gaming = /** @type {(inputs: Home_Category_GamingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaming`)
};

/**
* | output |
* | --- |
* | "Gaming" |
*
* @param {Home_Category_GamingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_gaming = /** @type {((inputs?: Home_Category_GamingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_GamingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_gaming(inputs)
	return en_home_category_gaming(inputs)
});